<template>
  <div class="order-detail">
    <div class="order-detail-info">
      <el-page-header class="page-header" @back="goBack" content="订单详情"></el-page-header>
      <div >
        <div class="order-state">
          <h1 style="text-align: center">
            <span>订单状态 ： </span>
            <div class="state">
              <p class="tag default" v-if="order.OrderStatus == -5">创建订单失败</p>
              <p class="tag danger" v-else-if="order.OrderStatus == -6">同步中</p>
              <p class="tag danger" v-else-if="order.OrderStatus == -4">账户余额不足</p>
              <p class="tag default" v-else-if="order.OrderStatus == -3">订单支付中</p>
              <p class="tag default" v-else-if="order.OrderStatus == -2">支付超时</p>
              <p class="tag default" v-else-if="order.OrderStatus == -1">已关闭</p>
              <p class="tag danger" v-else-if="order.OrderStatus == 0">待支付</p>
              <p class="tag success" v-else-if="order.OrderStatus == 1">已支付</p>
              <p class="tag info" v-else-if="order.OrderStatus == 2">提货中</p>
              <p class="tag info" v-else-if="order.OrderStatus == -9">异地库订单待确认</p>
              <p class="tag info" v-else-if="order.OrderStatus == 5">提货量已到阈值</p>
              <p class="tag warning" v-else-if="order.OrderStatus == 7">提货截止</p>
              <p class="tag info" v-else-if="order.OrderStatus == 8">订单完成</p>
              <p class="tag success" v-else-if="order.OrderStatus == 9">订单完成</p>
              <p class="tag info" v-else-if="order.OrderStatus == -12">合同暂停提货截止</p>
              <p class="tag info" v-else-if="order.OrderStatus == -11">异地库订单到期状态</p>
              <p class="tag danger" v-else-if="order.OrderStatus == -99">已删除</p>
              <p class="tag info" v-else-if="order.OrderStatus == -10">已关闭</p>
              <p class="tag danger" v-else-if="order.OrderStatus == -8">渠道订单推送装车系统失败</p>
              <p class="tag warning" v-else-if="order.OrderStatus == -7">合同订单余额不足</p>
            </div>
          </h1>
        </div>
        <div class="order-item">
          <div class="order-item-box order-product-info">
            <h1 class="order-item-title">产品信息</h1>
            <div class="flex-div">
              <div class="img">
                <img class="pic-img-100" :src="productImg" alt="">
              </div>
              <div class="info">
                <div class="title">{{ order.ProductName }}</div>
                <div class="company">提货地：{{ order.WarehouseName }}</div>
              </div>
              <div class="number">
                <div>订单数量</div>
                <div class="input">
                  {{ order.Quantity }} 吨
                </div>
              </div>
              <div class="price">
                <div>单价</div>
                <div class="price">￥ {{ toFixed(order.TransactionPriceStr) }} 元</div>
              </div>
            </div>

          </div>
        </div>
        <div class="order-info">
          <h1 style="font-size: 16px">订单信息</h1>
          <el-col :md="8" :sm="12" :xs="24"><strong>订单号：</strong> {{ id }}</el-col>
          <el-col :md="8" :sm="12" :xs="24"><strong>创建时间：</strong>{{ order.CreateTime | dateNoT }}</el-col>
          <el-col :md="8" :sm="12" :xs="24"><strong>提货地：</strong>{{ order.WarehouseName }}</el-col>
          <el-col :md="8" :sm="12" :xs="24"><strong>订单量：</strong>{{ order.Quantity }} 吨</el-col>
          <el-col :md="8" :sm="12" :xs="24"><strong>预提量：</strong>{{ order.EstimateQuantity }} 吨</el-col>
          <el-col :md="8" :sm="12" :xs="24"><strong>实提量：</strong>{{ order.ActualQuantity }} 吨</el-col>
          <el-col :md="8" :sm="12" :xs="24"><strong>订单金额：</strong>{{ order.AmountStr }} 元</el-col>
          <el-col :md="8" :sm="12" :xs="24"><strong>支付时间：</strong>{{ order.PaymentTime }}</el-col>
        </div>
        <div style="width: 990px;padding: 15px;" v-if="order.OrderStatus > 0">
          <h1 style="font-size: 16px;margin-bottom: 20px;">提货单信息</h1>
          <OrderLading :orderStatus="order.OrderStatus" :isEdit="true" :id="id" ref="OrderLading"
          @deleted="deleted" :ProductId="ProductId"></OrderLading>
        </div>
        <!--<div class="lading-info" v-if="order.OrderStatus > 0">-->
          <!--<h1>提货单信息-->
          <!--</h1>-->
          <!--<OrderLading :orderStatus="order.OrderStatus" :isEdit="true" :id="id" ref="OrderLading"-->
                       <!--@deleted="deleted" :ProductId="ProductId"></OrderLading>-->
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">

import OrderLading from '@/views/Me/OrderLading/OrderLading'
import DialogForm from '@/components/Dialogs/DialogForm';
import AutoForm from '@/components/AutoForm'

var AppealReasonType = [
  {
    value: 0,
    label: '缺量'
  },
  {
    value: 1,
    label: '机器故障'
  },
  {
    value: 2,
    label: '车辆未到场'
  },
  {
    value: 3,
    label: '超时未制卡'
  },
  {
    value: 4,
    label: '其他'
  }
]
export default {
  components: {
    OrderLading, DialogForm, AutoForm
  },
  props: {
    screen: {
      type: Object,
      default: () => {
      }
    },
    id: {
      type: String
    },
  },
  data() {
    return {
      sucessFlag: false,
      type: '',
      ProductId:'',
      visible: false,
      step: 0,
      url: {
        pay: SZH.assets.api + "/Order/OffProOrderToPay",
        pay2: SZH.assets.api + "/Order/OrderToPay",
        get: SZH.assets.api + '/Order/GetOrder',
        syncSAP: SZH.assets.api + '/Order/CreateOrderSyncSAP',
        checkPayState: SZH.assets.api + '/UnionPay/QueryOrderState',
        betchUpload: SZH.assets.api + '/Order/BatchBillSyncSAP',
        upload: SZH.assets.api + '/Order/ImportBillInfo',
        sendPhoneVCodeOld: SZH.assets.api + "/Authen/SendVerifyCode2",
        SaveCustomAppealInfo: SZH.assets.api + '/Custom/SaveCustomAppealInfo',
        GetCustomAppealInfo: SZH.assets.api + '/Custom/GetCustomAppealInfo'

      },
      order: {

      },
      loading: true,
      uploading: false,
    }
  },
  methods: {
    deleted() {
      this.loadData();
    },
    betchUpload() {
      var self = this;
      self.loading = true;
      self.$http.post(self.url.betchUpload, {
        Data: self.id
      }).then(result => {
        if (result.State == 1) {
          self.loadData();
        } else {
          this.$message.error(result.Message);
        }
        self.loading = false;
      }, () => {
      });
    },
    onSavedBill() {
      this.loadData();
      this.$refs['OrderLading'].reload();
    },
    goBack() {
      this.$router.push({
         path: '/My/userInfo'
      })
    },
    turnTo(url) {
      this.$router.push({
        path: url
      })
    },
    onCannotpay() {
      this.loadData();
    },
    toFixed(number) {
      var num = parseFloat(number);
      return num != null && num != undefined ? num.toFixed(2) : '0.00'
    },
    loadData() {
      var self = this;
      self.$http.post(self.url.get, {
        KeyValue: self.id
      })
        .then(result => {
          if (result.state == true && result.data) {
            self.order = result.data;
          } else {
            self.order = {};
            // self.$router.push({
            //   path: '/My/OrderList'
            // })
          }
        }, () => {
        });
    },
  },
  computed: {
    productImg() {
      return this.order.ProductPicUrl ? SZH.assets.image + this.order.ProductPicUrl : '';
    },
  },
  created() {
  },
  mounted() {
    // this.type = this.$route.query.type;
    // this.ProductId = this.$route.query.ProductId;
    this.loadData();
  },
  watch: {}
}
</script>

<style type="text/css" scoped>
.flex-div {
  display: flex;
  width: 100%;
  border: 1px dashed #ddd;
  padding: 20px 5px;
}

.img, .info, .number, .price {
  width: 100%;
  line-height: 200%;
  position: relative;
}

.info {
  width: 150%;
}

.img {
  width: 50%;
}

.img img.product-ticket {
  width: 30px;
  right: 0px;
  margin-right: 11px;
  position: absolute;
  top: 0px;
}

.img img.pic-img-100 {
  width: 100%;
  height: 100%;
  padding-right: 10px;
}

/* .order-detail-info { */
/* border: 1px solid #efefef; */
/* padding: 30px 15px 0; */
/* margin-bottom: 30px; */
/* border-radius: 30px; */
/* } */

.page-header {
  padding-bottom: 10px;
  border-bottom: 1px solid #efefef;
}

/* 顶部logo - 搜索条 */

.top-logo-query {
  height: 100px;
  line-height: 100px;
  /* border: 1px solid #000; */
}

.top-logo-query > .logo {
  margin-top: 30px;
  float: left;
  cursor: pointer;
}

.top-logo-query > .search {
  margin-left: 50px;
  width: 500px;
}

/* 订单详情 */
.order-detail {
  margin: 0 auto;
}

/* 支付 */

.order-pay {
  margin-top: 25px;
  /* box-shadow: 0 0 6px rgba(180,180,180,0.75); */
  padding: 30px 20px;
  overflow: hidden;
  text-align: center;
  line-height: 64px;
}

.order-pay > div {
  width: 420px;
  margin: 0 auto;
  position: relative;
}

.order-pay > div > img {
  height: 64px;
  float: left;
}

.order-pay > div > p {
  margin-left: 20px;
  float: left;
  font-size: 22px;
}

.order-pay > div > p > button {
  margin-left: 15px;
  font-size: 22px;
}

/* 订单详情 */

.order-state {
  margin-top: 25px;
  /* box-shadow: 0 0 6px rgba(180,180,180,0.75); */
  padding: 30px 20px;
  overflow: hidden;
}

.order-state > h1 {
  line-height: 40px;
  padding-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.order-state > h1 > span {
  font-size: 22px;
}

.order-state > h1 > div.state {
}

.order-state > h1 > div.state > p {
  font-size: 18px;
  font-weight: 700;
}

.order-state > h1 > div.state > p.default {
  color: #808080;
}

.order-state > h1 > div.state > p.danger {
  color: #F56C6C;
}

.order-state > h1 > div.state > p.success {
  color: #67C23A;
}

.order-state > h1 > div.state > p.info {
  color: #5fadff;
}

.order-state > div.flow {
  margin-top: 25px;
  width: 100%;
  height: 80px;
  text-align: center;
  float: left;
}

/* 订单信息 */
.order-info {
  /*margin: 20px 0;*/
  /* box-shadow: 0 0 6px rgba(180,180,180,0.75); */
  padding: 20px;
  overflow-y: hidden;
  /*margin-top: 25px;*/
  line-height: 28px;
  font-size: 15px;
}

.order-info > h1 {
  font-size: 22px;
  height: 40px;
  padding-bottom: 5px;
  overflow: hidden;
  border-bottom: 1px solid #efefef;
  margin-bottom: 25px;
}

/* 产品信息 */
.order-item {
  margin-top: 0px;
  margin-bottom: 0px;
}

.order-item .order-item-title {
  font-size: 16px;
  width: 100%;
  height: 40px;
  padding-bottom: 5px;
  overflow: hidden;
  border-bottom: 1px solid #efefef;
  margin-bottom: 25px;
}

.order-item > .order-item-box {
  font-size: 15px;
  padding: 0 65px;
  overflow: hidden;
}

.order-item > .order-item-box > div {
  margin-top: 10px;
}

.order-item > .order-item-box > div.col-12 {
  display: inline-block;
  width: calc(50% - 10px);
}

.order-item > .order-item-box > div > span {
  display: inline-block;
  width: 100px;
  padding-right: 10px;
  text-align: right;
}

.order-item > .order-item-box.order-product-info {
  /* border: 1px solid #e5e5e5; */
  /* box-shadow: 0 0 6px rgba(0,0,0,.1); */
  padding: 15px;
  position: relative;
  overflow: hidden;
}

.order-product-info > .img {
  width: 150px;
  height: 150px;
  float: left;
  margin-right: 15px;
  position: relative;
}

.order-product-info > .img > img {
  width: 140px;
  height: 140px;
  position: absolute;
  right: 0;
  top: -10px;
}

.order-product-info > .img > img.product-ticket {
  height: 30%;
  width: auto;
}


/*.order-product-info > div {*/
/*float: left;*/
/*height: 100%;*/
/*width: calc(100% - 550px);*/
/*}*/

.order-product-info > div > .title {
  font-size: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  word-break: break-all;
  margin-top: 10px;
}

.order-product-info > div > .company {
  font-size: 14px;
  color: #808080;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
  margin-top: 13px;
  line-height: 15px;
}

.order-product-info > div.number {
  width: 150px;
}

.order-product-info > div.number > div.input {
  line-height: 100px;
}

.order-product-info > div.price {
  width: 120px;
  float: right;
}

.order-product-info > div.price > .price {
  line-height: 100px;
}

/* 提货信息 */
.lading-info {
  width: 100%;
  line-height: 35px;
  margin: 0px;
  padding: 30px 20px;
}

.lading-info > h1 {
  line-height: 40px;
  padding-bottom: 5px;
  overflow: hidden;
  border-bottom: 1px solid #efefef;
}
</style>



// WEBPACK FOOTER //
// src/views/Me/OrderDetail/OrderDetail.vue